import React, { Component } from 'react';
import yaml from 'js-yaml';
import Fade from 'react-reveal/Fade';

import { buildPath } from '../utils/route_utils.js'
import { updateSEO } from '../utils/seo_utils'

import Navbar from '../components/Navbar'
import Footer from '../components/Footer'
import AnnouncementBanner from '../components/AnnouncementBanner'
import Breadcrumb from '../components/Breadcrumb'

import '../css/SolutionPage.css';

class SolutionPage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      lang: this.props.lang,
      content: [],
      productSections: [],
      productItems: [],
      productDescs: {},
      expandedCard: null,
      expandedProduct: null,
    }

    this.navigate = this.navigate.bind(this)
    this.update_lang = this.update_lang.bind(this)
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.lang !== this.state.lang) {
      this.setState({ lang: nextProps.lang });
    }
  }

  componentDidMount() {
    updateSEO('solutions', this.state.lang, '/solutions');
    // Fetch custom solutions
    fetch(process.env.PUBLIC_URL + '/yaml/custom_product_info.yaml')
    .then(response => response.text())
    .then(text => {
      const parsed = yaml.load(text);
      this.setState({ content: parsed.content });
    });

    // Fetch product catalog
    fetch(process.env.PUBLIC_URL + '/yaml/section_product.yaml')
    .then(response => response.text())
    .then(text => {
      const parsed = yaml.load(text)["products"];
      this.setState({ productSections: parsed.section, productItems: parsed.item });
    });

    // Fetch product descriptions from tech_intro
    fetch(process.env.PUBLIC_URL + '/yaml/product_info.yaml')
    .then(response => response.text())
    .then(text => {
      const techContent = yaml.load(text)["tech_content"];
      const descs = {};
      Object.keys(techContent).forEach(key => {
        const entry = techContent[key];
        // Get the first tech_intro content as short description
        const webContent = entry.web_content;
        let introText = { zh: "", en: "", ja: "" };
        if (webContent) {
          const sections = Object.values(webContent);
          for (const items of sections) {
            if (Array.isArray(items)) {
              const intro = items.find(i => i.type === "tech_intro");
              if (intro && intro.content) {
                introText = intro.content;
                break;
              }
            }
          }
        }
        descs[key] = introText;
      });
      this.setState({ productDescs: descs });
    });
  }

  update_lang(newLang) {
    this.props.updateLang(newLang);
  }

  navigate(route) {
    window.location.href = buildPath(this.state.lang, route);
  }

  stripHtml(html) {
    const tmp = document.createElement("div");
    tmp.innerHTML = html;
    return tmp.textContent || tmp.innerText || "";
  }

  truncate(text, maxLen) {
    const plain = this.stripHtml(text);
    if (plain.length <= maxLen) return plain;
    return plain.substring(0, maxLen).trim() + '...';
  }

  render() {
    const lang = this.state.lang;
    const heroTitle = { zh: "產品與方案", en: "Products & Solutions", ja: "製品とソリューション" };
    const heroSub = {
      zh: "從標準化產品到客製化 AI 機器人與自動化方案，全方位滿足您的需求。",
      en: "From standardized products to custom AI robotics and automation — everything you need in one place.",
      ja: "標準製品からカスタムAIロボティクス・自動化ソリューションまで、あらゆるニーズに対応。"
    };

    const productLabel = { zh: "產品", en: "Products", ja: "製品" };
    const productSub = {
      zh: "我們的標準化產品線，可直接部署或快速客製化。",
      en: "Our standardized product lines — ready to deploy or quickly customize.",
      ja: "すぐに導入、またはカスタマイズ可能な標準製品ラインナップ。"
    };
    const customLabel = { zh: "客製化方案", en: "Custom Solutions", ja: "カスタムソリューション" };
    const customSub = {
      zh: "針對特定產業與場域需求，量身打造的 AI 與自動化解決方案。",
      en: "Tailored AI and automation solutions designed for specific industries and environments.",
      ja: "特定の産業・環境に合わせたAI・自動化ソリューション。"
    };
    const viewProduct = { zh: "了解更多", en: "Learn More", ja: "詳しく見る" };

    // Flatten custom solution cards
    const customCards = [];
    if (this.state.content) {
      this.state.content.forEach(group => {
        if (group.content) {
          group.content.forEach(item => {
            customCards.push({
              title: { zh: item.zh, en: item.en, ja: item.ja },
              img_url: item.img_url,
              excerpt: {
                zh: item.detail_content.zh.subc4,
                en: item.detail_content.en.subc4,
                ja: item.detail_content.ja.subc4
              },
              techs: item.detail_content.en.subl2 || [],
              detail: item.detail_content
            });
          });
        }
      });
    }

    const sectionColors = ["var(--main-color)", "var(--sub2-color)", "var(--sub1-color)"];

    return (
      <div className={lang + " solution_page"}>
        <AnnouncementBanner lang={lang} />
        <Navbar lang={lang} updateLangFunc={this.update_lang} />
        <Breadcrumb lang={lang} items={[{ label: { zh: "產品與方案", en: "Products & Solutions", ja: "製品とソリューション" } }]} />

        {/* Hero */}
        <div className="sol_hero">
          <Fade duration={800}>
            <h1 className="sol_hero_title">{heroTitle[lang]}</h1>
            <p className="sol_hero_sub">{heroSub[lang]}</p>
          </Fade>
        </div>

        {/* ========== PRODUCTS SECTION ========== */}
        <div className="sol_section_header">
          <div className="sol_section_tag" style={{ background: 'var(--main-color)', color: 'var(--dark-color)' }}>
            {productLabel[lang]}
          </div>
          <p className="sol_section_sub">{productSub[lang]}</p>
        </div>

        {this.state.productItems.map((sectionProducts, sIdx) => (
          <div key={sIdx} className="sol_product_group">
            <div className="sol_product_group_label">
              <span className="sol_product_group_bar" style={{ background: sectionColors[sIdx] || sectionColors[0] }} />
              <h3>{this.state.productSections[sIdx] ? this.state.productSections[sIdx][lang] : ''}</h3>
            </div>
            <div className="sol_product_grid">
              {sectionProducts.map((product, pIdx) => {
                const pid = product.href_link.id;
                const isComingSoon = product.product_status && product.product_status.status === 2;
                const productKey = sIdx + '-' + pIdx;
                const isExpanded = isComingSoon && this.state.expandedProduct === productKey;
                const desc = this.state.productDescs[pid] || {};
                const descText = isComingSoon ? (product.product_desc ? product.product_desc[lang] : "") : (desc[lang] || "");
                return (
                  <Fade key={pIdx} duration={500} delay={pIdx * 60}>
                    <div
                      className={"sol_product_card" + (isComingSoon ? " sol_product_card_coming" : "") + (isExpanded ? " sol_product_card_expanded" : "")}
                      onClick={() => {
                        if (isComingSoon) {
                          this.setState({ expandedProduct: isExpanded ? null : productKey });
                        } else {
                          this.navigate('/tech/' + pid);
                        }
                      }}
                    >
                      <div className="sol_product_card_top">
                        <div className="sol_product_card_img">
                          <img src={product.product_img} alt={product.product_title[lang]} />
                        </div>
                        {isComingSoon && (
                          <div className="sol_product_card_overlay">
                            <span className="sol_product_coming_tag">{product.product_status[lang]}</span>
                          </div>
                        )}
                        {!isComingSoon && product.product_status && product.product_status[lang] !== "-" && (
                          <span className="sol_product_badge">{product.product_status[lang]}</span>
                        )}
                      </div>
                      <div className="sol_product_card_body">
                        <h4 className="sol_product_card_title">{product.product_title[lang]}</h4>
                        {descText && (
                          <p className={isExpanded ? "sol_product_card_desc sol_product_card_desc_full" : "sol_product_card_desc"}>{isExpanded ? descText : this.truncate(descText, 120)}</p>
                        )}
                        {isComingSoon ? (
                          <span className="sol_product_card_link">{isExpanded ? (lang === 'zh' ? '收起' : lang === 'ja' ? '閉じる' : 'Show less') : (lang === 'zh' ? '了解更多' : lang === 'ja' ? '詳しく見る' : 'Learn more')} {isExpanded ? '▲' : '▼'}</span>
                        ) : (
                          <span className="sol_product_card_link">{viewProduct[lang]} &rarr;</span>
                        )}
                      </div>
                    </div>
                  </Fade>
                );
              })}
            </div>
          </div>
        ))}

        {/* ========== CUSTOM SOLUTIONS SECTION ========== */}
        <hr className="sol_divider" />
        <div className="sol_section_header sol_section_header_custom">
          <div className="sol_section_tag" style={{ background: 'var(--dark-color)', color: '#fff' }}>
            {customLabel[lang]}
          </div>
          <p className="sol_section_sub">{customSub[lang]}</p>
        </div>

        <div className="sol_grid">
          {customCards.map((card, idx) => {
            const isExpanded = this.state.expandedCard === idx;
            const detail = card.detail[lang] || card.detail['en'];
            return (
            <Fade key={idx} duration={600} delay={idx * 80}>
              <div
                className={"sol_card" + (isExpanded ? " sol_card_expanded" : "")}
                onClick={() => this.setState({ expandedCard: isExpanded ? null : idx })}
              >
                <div className="sol_card_img">
                  <img src={card.img_url} alt={card.title[lang]} />
                </div>
                <div className="sol_card_body">
                  <h3 className="sol_card_title">{card.title[lang]}</h3>
                  <p className={isExpanded ? "sol_card_excerpt sol_card_excerpt_full" : "sol_card_excerpt"}>{card.excerpt[lang]}</p>

                  {isExpanded && (
                    <div className="sol_card_detail">
                      {detail.subt3 && detail.subc3 && (
                        <div className="sol_card_detail_block">
                          <h4 className="sol_card_detail_label">{detail.subt3}</h4>
                          <p className="sol_card_detail_text">{detail.subc3}</p>
                        </div>
                      )}
                      {detail.subt2 && detail.subl2 && detail.subl2.length > 0 && (
                        <div className="sol_card_detail_block">
                          <h4 className="sol_card_detail_label">{detail.subt2}</h4>
                          <div className="sol_card_tags sol_card_detail_tags">
                            {detail.subl2.map((tech, tidx) => (
                              <span key={tidx} className="sol_tag">{tech}</span>
                            ))}
                          </div>
                        </div>
                      )}
                    </div>
                  )}

                  {!isExpanded && (
                    <div className="sol_card_tags">
                      {card.techs.slice(0, 4).map((tech, tidx) => (
                        <span key={tidx} className="sol_tag">{tech}</span>
                      ))}
                    </div>
                  )}

                  <span className="sol_card_toggle">
                    {isExpanded
                      ? (lang === 'zh' ? '收起' : lang === 'ja' ? '閉じる' : 'Show less')
                      : (lang === 'zh' ? '了解更多' : lang === 'ja' ? '詳しく見る' : 'Learn more')
                    } {isExpanded ? '▲' : '▼'}
                  </span>
                </div>
              </div>
            </Fade>
            );
          })}
        </div>

        <Footer lang={lang} navigate={this.navigate} />
      </div>
    );
  }
}

export default SolutionPage;
